import {
  Member,
  Benefit
} from '@td/membersupport';
import { get, upperFirst } from 'lodash';

const formatProducts = (products) => {
  return (products || []).map(p => {
    const prdtName = get(p, 'displayName', '');
    return prdtName === 'Nutrition' && p.conditionFlg === 'Y' ? 'Nutrition (Conditional)' : prdtName;
  });
};

function unmaskedMember(member, restrictions) {
  return Member({
    memberId: get(member, 'memberId'),
    defaultProfile: {
      benefits: (get(member, 'mrns') || []).map(benefit => Benefit({
        mrnId: get(benefit, 'mrnId'),
        sponsor:           get(benefit, 'group.name'),
        hasWebAccess:      get(benefit, 'group.hasWebAccess'),
        canAccessOneapp:   get(benefit, 'group.oneAppFlag'),
        classification:    benefit.isPrimary ? 'Primary' : 'Dependent',
        isActive:          get(benefit, 'isActive'),
        healthPlanId:      get(benefit, 'sourceHealthPlanId') || get(benefit, 'sourceMrnId'),
        coverageStartDate: get(benefit, 'coverageStartDate'),
        coverageEndDate:   get(benefit, 'coverageEndDate'),
        products:          formatProducts(get(benefit, 'serviceSpecialties', []))
      })),
      lastMhdUpdate:     get(member, 'lastMhdUpdate', 'No MHD'),
      securityQuestions: get(member, 'person.securityQuestions', [])
    },
    firstName:        get(member, 'firstName'),
    lastName:         get(member, 'lastName'),
    dob:              get(member, 'dateOfBirth'),
    email:            get(member, 'primaryEmailAddress'),
    gender:           upperFirst((get(member, 'gender', '')).substring(7).toLowerCase()),
    phoneNumber:      get(member, 'phoneNumbers', []).map(p => p.internationalFormattedNumber).join(', '),
    username:         get(member, 'userName'),
    vip:              get(member, 'vipFlag'),
    street:           `${get(member, 'residenceAddress.addressLine1', '')} ${get(member, 'residenceAddress.addressLine2', '')}`,
    residentState:    get(member, 'residenceAddress.state', ''),
    city:             get(member, 'residenceAddress.city', ''),
    zipCode:          get(member, 'residenceAddress.zipcode', ''),
    registered:       restrictions.registered,
    canRegister:      member.status !== 'MEMBERSTATUS_ACT',
    canceled:         member.status === 'MEMBERSTATUS_CAN',
    suspended:         member.status === 'MEMBERSTATUS_SUS',
    canResetPassword: restrictions.canResetPassword,
    canImpersonate:   restrictions.canImpersonate,
  });
}

export default unmaskedMember;
